<template>
  <Multiselect
    :id="htmlId"
    v-model="valueHandler"
    label="label"
    trackBy="id"
    valueByPath="id"
    :options="options"
    :max="multiple"
    :disabled="visibility > 0"
    :afterList="projectLock ? ['Zobrazit všechny...', showAll] : []"
  ></Multiselect>
</template>

<script>
import DataTypeMixin from 'CORE/mixins/dataType'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import { createDataTypeValue } from '../utils'
import { get, union, map } from 'lodash'
import labels from 'CORE/utils/labels'

const isTaggedAs = (propertyType, tagName) => {
    return get(propertyType, `settings.systags.${tagName}`, false)
}

export default {
    name: 'Link',
    components: {
        Multiselect,
    },
    mixins: [
        DataTypeMixin,
    ],
    data() {
        return {
            projectLock: true,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return get(this, 'value.value.value', null)
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    if (this.visibility === 0) {
                        this.$emit('input', createDataTypeValue(value))
                    }
                }
            },
        },
        options() {
            try {
                const entityType = get(this.propertyType, 'settings.link.entity')
                if (entityType === 'TASK') {
                    let tasks = []
                    if (this.projectLock) {
                        tasks = union(map(this.valueHandler, id => {
                            return this.$store.getters.taskById(id)
                        }), this.$store.getters.tasksByProjectId(get(this.meta, `task.project.id`)))
                    } else {
                        tasks = this.$store.getters.tasks
                    }
                    return map(tasks, t => {
                        return {
                            id: t.id,
                            label: labels.task(this.$store.getters.taskById(t.id)),
                        }
                    })
                }
                if (entityType === 'PROJECT') {
                    return map(this.$store.getters.projects, p => {
                        return {
                            id: p.id,
                            label: labels.project(this.$store.getters.getProjectById(p.id)),
                        }
                    })
                }
            } catch (e) {
                console.error(e)
            }
            return []
        },
        multiple() {
            return get(this.propertyType, 'multiple', 1)
        },
        readOnly() {
            // return isTaggedAs(this.propertyType, 'parentTask')
            return false
        },
    },
    created() {
        const isParentTask = isTaggedAs(this.propertyType, 'parentTask')
        const isDependentOn = isTaggedAs(this.propertyType, 'dependentOn')
        const haveParentTaskId = !!get(this.meta, 'parentTask', false)
        const entityType = get(this.propertyType, 'settings.link.entity')

        if (isParentTask && haveParentTaskId) {
            this.valueHandler = [get(this.meta, 'parentTask', null)]
        }
        if (entityType === 'TASK') {
            if (isParentTask || isDependentOn) {
                this.projectLock = true
            } else {
                this.projectLock = false
            }
        }
    },
    methods: {
        showAll() {
            this.projectLock = false
        },
    },
}
</script>
